var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRightArrayGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.6888 2.39734C10.2832 2.00887 10.2832 1.37904 10.6888 0.99057C11.0943 0.602101 11.7518 0.602101 12.1574 0.99057L17.6958 6.29583C17.8986 6.49007 18 6.74464 18 6.99922C18 7.1341 17.972 7.2627 17.9212 7.37999C17.8705 7.49731 17.7954 7.60723 17.6958 7.7026L12.1574 13.0079C11.7518 13.3963 11.0943 13.3963 10.6888 13.0079C10.2832 12.6194 10.2832 11.9896 10.6888 11.6011L14.4545 7.99396L1.03846 7.99395C0.464933 7.99395 -2.50614e-06 7.5486 -2.45811e-06 6.99922C-2.41008e-06 6.44984 0.464933 6.00448 1.03846 6.00448L14.4545 6.00448L10.6888 2.39734Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightArrayGray);
export default __webpack_public_path__ + "static/media/iconRightArrayGray.c18b0c779411f412198112c29cb7c0dd.svg";
export { ForwardRef as ReactComponent };